import React from 'react';
import { motion } from 'framer-motion';
import { RocketIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-10 md:py-16 bg-brand-blue text-white overflow-hidden relative" data-id="element-79">
      {/* Decorative background circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-80"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-81"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-83">
          <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-5 backdrop-blur-sm" data-id="element-84">
            <RocketIcon className="w-7 h-7 text-brand-orange" data-id="element-85" />
          </div>

          <h2 className="text-2xl md:text-4xl font-bold mb-5 leading-tight" data-id="element-86">
            Introducing the <br data-id="element-87" />
            <span className="inline-block mt-2 px-5 py-1.5 bg-brand-orange text-white rounded-2xl shadow-lg transform -rotate-1" data-id="element-88">
              Novelty Rotation System
            </span>
          </h2>

          <div className="text-base md:text-lg text-blue-50 leading-relaxed space-y-4 text-left bg-white/5 p-6 rounded-2xl backdrop-blur-sm border border-white/10" data-id="element-89">
            <p data-id="element-90">
              This isn't just a list of ideas; it's a{' '}
              <strong data-id="element-91">tactical deployment strategy</strong>.
            </p>
            <p data-id="element-92">
              By using timed{' '}
              <span className="font-bold text-brand-cream border-b-2 border-brand-orange" data-id="element-93">
                "Micro-Moments"
              </span>{' '}
              and the{' '}
              <span className="font-bold text-brand-cream border-b-2 border-brand-orange" data-id="element-94">
                "Lap-Safe" engagement framework
              </span>
              , you keep your toddler's brain busy and their hands moving.
            </p>
            <p className="text-center font-bold text-xl mt-5 text-brand-cream" data-id="element-95">
              Zero WiFi required. Zero charging ports needed. 🎒
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}